import { CtaButtonAlign, CtaButtonBlockData, CtaButtonVariant } from '@longy/common/cms'

import { cn } from '../../lib/utils'
import { BlockCta, BlockSection } from './shared'

const ALIGNMENT: Record<CtaButtonAlign, string> = {
    [CtaButtonAlign.LEFT]: 'justify-start',
    [CtaButtonAlign.CENTER]: 'justify-center',
    [CtaButtonAlign.RIGHT]: 'justify-end',
}

export const CtaButtonRenderer = ({ label, link, variant, align }: CtaButtonBlockData) => {
    if (!label) return null

    return (
        <BlockSection className="!py-6">
            <div className={cn('flex', ALIGNMENT[align])}>
                <BlockCta
                    label={label}
                    link={link}
                    variant={variant === CtaButtonVariant.SECONDARY ? 'secondary' : 'primary'}
                    className="px-8 py-3 text-base"
                />
            </div>
        </BlockSection>
    )
}
